import { QuestionVisibility } from '@models/api/question';

/**
 * The titles of the options in the "Who can see this" selector (VisibilitySelector), in one place so
 * copy that names an option says it in the words the author tapped.
 */
export const VISIBILITY_OPTION_TITLE = {
  [QuestionVisibility.anyone]: 'Anyone can help - Meetverse (global)',
  [QuestionVisibility.my_network]: 'My network',
  [QuestionVisibility.space_only]: 'Only in selected Spaces',
} as const;
